var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTooptipGreenTick(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7,
    height: 5.061,
    viewBox: "0 0 7 5.061",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_58102",
    "data-name": "Path 58102",
    d: "M2362.319,455.674a.6.6,0,0,0-.4-.394.643.643,0,0,0-.674.19c-.885.891-1.789,1.794-2.663,2.667l-.7.7-.646-.646-.826-.827a.618.618,0,0,0-.632-.161.586.586,0,0,0-.427.488.623.623,0,0,0,.2.567l.446.444c.452.448.919.912,1.369,1.377a.709.709,0,0,0,.508.235h0a.718.718,0,0,0,.512-.231c.9-.913,1.825-1.836,2.719-2.728l.979-.979.019-.019a1.085,1.085,0,0,0,.1-.111A.623.623,0,0,0,2362.319,455.674Z",
    transform: "translate(-2355.348 -455.251)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooptipGreenTick);
export default __webpack_public_path__ + "static/media/tooptip_green_tick.92c20002.svg";
export { ForwardRef as ReactComponent };